import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h1>{`Learning iOS development`}</h1>
    <p>{`When I first started coding, I assumed after making websites for a bit I would graduate into real coding—native apps, probably for the iPhone. I’ve made several small attempts over the years to begin learning iOS development, but nothing ever really stuck for me.`}</p>
    <p>{`I have a good dozen solid ideas for iOS apps (productivity, utility, personal) that can only be well-executed with a native Swift-powered app.`}</p>
    <p>{`Every tutorial I’ve read just…doesn’t really click. SwiftUI will absolutely lower the barrier to entry, especially once Catalina is released & it’s natively easy to use. But so far nothing’s really worked for me.`}</p>
    <p>{`One of the biggest barriers for me is needing to use a Mac—I have only opened my MacBook a few times in the past month, all to run the Arduino IDE for one of my classes. The inability to develop native apps directly on iPad is disappointing (& in my opinion, kind of inexcusable at this point).`}</p>
    <p>{`At some point in my career, even though I’m not at all expecting to switch to it, I look forward to building some native apps.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      